import { useRef } from 'react';
import classnames from 'classnames';
import compact from 'lodash/compact';

import style from './SearchInput.module.scss';

import { Input, InputProps, InputTheme, InputModifiers } from '../Input';
import { Icon, IconType } from '../Icon';

export enum Modifiers {
    // @ts-ignore
    ReverseIcon = style.revert,
}

export interface SearchInputParams extends Omit<InputProps, 'modifiers' | 'theme' | 'redesign'> {
    withoutBottomLine?: boolean;
    withoutPaddings?: boolean;
    withSmallLeftPadding?: boolean;
    smallIcon?: boolean;
    withBorder?: boolean;
    modifiers?: Modifiers[];
    theme?: SearchInputTheme;
}

export enum SearchInputTheme {
    // @ts-ignore
    White = style.white,
}

interface Props extends SearchInputParams {
    onCancelClick?(): void;
}

export function SearchInput({
    value = '',
    withoutBottomLine,
    withoutPaddings,
    smallIcon,
    withBorder,
    onCancelClick,
    title,
    modifiers,
    withSmallLeftPadding,
    theme,
    ...props
}: Props) {
    const searchInput = useRef<HTMLElement | null>(null);

    const handleSearchClick = (): void => {
        searchInput.current?.focus();
    };

    const handleCancelClick = (): void => {
        onCancelClick?.();
        searchInput.current?.focus();
    };

    const isHideCancelIcon = value === '';

    return (
        <div
            className={classnames([
                style.root,
                smallIcon && style.root_smallIcon,
                withBorder && style.root_withBorder,
                !isHideCancelIcon && style.root_withContent,
                !!modifiers && [...modifiers],
                !!theme && theme,
            ])}
        >
            <div className={style.searchIconWrapper}>
                <div
                    className={style.searchIcon}
                    onClick={handleSearchClick}
                >
                    <Icon type={IconType.SEARCH_REDESIGN} />
                </div>
            </div>
            <div className={style.inputWrapper}>
                <Input
                    theme={InputTheme.Search}
                    modifiers={compact([
                        withoutBottomLine && InputModifiers.WithoutBottomLine,
                        withoutPaddings && InputModifiers.WithoutPaddings,
                        InputModifiers.NoBorder,
                        InputModifiers.InheritFont,
                        InputModifiers.CustomParentWrapper,
                        withSmallLeftPadding && InputModifiers.WithSmallLeftPadding,
                    ])}
                    value={value}
                    placeholder={title}
                    inputRef={searchInput}
                    {...props}
                />
            </div>
            {onCancelClick && (
                <div
                    className={classnames([style.cancelIconWrapper, isHideCancelIcon && style.hide])}
                    onClick={handleCancelClick}
                >
                    {theme === SearchInputTheme.White ? (
                        <Icon type={IconType.REMOVE_REDESIGN} />
                    ) : (
                        <div className={style.cancelIcon}>+</div>
                    )}
                </div>
            )}
        </div>
    );
}
